import { api } from './client';
import type { PSDProject, ProjectAnnotation, Paginated } from '@/types';

export const projectsApi = {
  async list(filters: { status?: string; contract?: number; search?: string } = {}): Promise<Paginated<PSDProject>> {
    const { data } = await api.get<Paginated<PSDProject>>('/projects/', { params: filters });
    return data;
  },
  async get(id: number): Promise<PSDProject> {
    const { data } = await api.get<PSDProject>(`/projects/${id}/`);
    return data;
  },
  async create(payload: { number: string; contract: number; construct?: number | null }, pdf?: File): Promise<PSDProject> {
    if (pdf) {
      const fd = new FormData();
      fd.append('number', payload.number);
      fd.append('contract', String(payload.contract));
      if (payload.construct) fd.append('construct', String(payload.construct));
      fd.append('pdf_file', pdf);
      const { data } = await api.post<PSDProject>('/projects/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      return data;
    }
    const { data } = await api.post<PSDProject>('/projects/', payload);
    return data;
  },
  async submit(id: number): Promise<PSDProject> { return (await api.post(`/projects/${id}/submit/`)).data; },
  async approve(id: number): Promise<PSDProject> { return (await api.post(`/projects/${id}/approve/`)).data; },
  async reject(id: number): Promise<PSDProject> { return (await api.post(`/projects/${id}/reject/`)).data; },
  async addAnnotation(payload: { project: number; page: number; x: number; y: number; text: string }): Promise<ProjectAnnotation> {
    const { data } = await api.post<ProjectAnnotation>('/project-annotations/', payload);
    return data;
  },
  async deleteAnnotation(id: number): Promise<void> { await api.delete(`/project-annotations/${id}/`); },
};
